import { Table, Thead, Tbody, Tfoot, Tr, Th, Td } from "@chakra-ui/react";

const PedidoTable = ({ pedidos }) => {
  // Função para converter a data no formato "DD/MM/YYYY" para um objeto Date
  const parseDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  // Ordenar os pedidos pela data de emissão (do mais recente para o mais antigo)
  const pedidosOrdenados = [...pedidos].sort(
    (a, b) => parseDate(b.emissao) - parseDate(a.emissao)
  );

  // Calcular os totais e médias
  const totais = pedidosOrdenados.reduce(
    (acc, pedido) => {
      pedido.itens.forEach((item) => {
        acc.valorTotal += item.valor_produto || 0;
        acc.volumeTotal += parseFloat(pedido.volume) || 0;
        acc.quantidadeTotal += item.qtde_produto || 0;

        // Calcular médias para Rent R$/Lt e Rent (%)
        if (item.qtde_produto > 0) {
          const rentRsLt =
            (item.valor_produto - item.custo_total) / item.qtde_produto;
          const rentPercent = (item.valor_produto / item.custo_total - 1) * 100;

          acc.rentRsLtTotal += rentRsLt || 0;
          acc.rentPercentTotal += rentPercent || 0;
          acc.itemCount += 1; // Contar itens para média
        }
      });
      return acc;
    },
    {
      valorTotal: 0,
      volumeTotal: 0,
      quantidadeTotal: 0,
      rentRsLtTotal: 0,
      rentPercentTotal: 0,
      itemCount: 0,
    }
  );

  const mediaRentRsLt =
    totais.itemCount > 0
      ? (totais.rentRsLtTotal / totais.itemCount).toFixed(4)
      : 0;
  const mediaRentPercent =
    totais.itemCount > 0
      ? (totais.rentPercentTotal / totais.itemCount).toFixed(2)
      : 0;

  const renderCabecalho = () => (
    <Thead bg="#007abe" position="sticky" top="0" zIndex="100" boxShadow="md">
      <Tr>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Tipo
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          n.º
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Cond. Pg
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Status
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Valor
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Vol
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Produto
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Qtd
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          P. Unit.
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
          borderRight="1px solid"
          borderColor="rgba(255, 255, 255, 0.2)"
        >
          Rent R$/Lt
        </Th>
        <Th
          fontSize="sm"
          color="white"
          fontWeight="bold"
          textTransform="uppercase"
          letterSpacing="wide"
          px={4}
          py={4}
        >
          Rent (%)
        </Th>
      </Tr>
    </Thead>
  );

  return (
    <Table
      variant="simple"
      size="sm"
      bg="white"
      borderRadius="lg"
      overflow="hidden"
    >
      {renderCabecalho()}
      <Tbody fontSize="sm">
        {pedidosOrdenados.length > 0 ? (
          pedidosOrdenados.map((pedido, index) =>
            pedido.itens.map((item, itemIndex) => {
              const rentRsLt = (
                (item.valor_produto - item.custo_total) /
                item.qtde_produto
              ).toFixed(4);
              const rentPercent = (
                (item.valor_produto / item.custo_total - 1) *
                100
              ).toFixed(2);

              return (
                <Tr
                  key={`${index}-${itemIndex}`}
                  _hover={{
                    bg: "gray.50",
                    transform: "scale(1.01)",
                  }}
                  transition="all 0.2s"
                >
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {pedido.tipo}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {pedido.numero}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {/* {pedido.cond_pgto} */}
                    {pedido.emissao}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {/* {pedido.status || "-"} */}
                    {pedido.cond_pgto}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    fontWeight="semibold"
                  >
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(item.valor_produto)}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {pedido.volume}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {item.descricao_produto}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {item.qtde_produto}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {`R$ ${item.preco_unitario.toFixed(4).replace(".", ",")}`}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                  >
                    {rentRsLt}
                  </Td>
                  <Td
                    px={4}
                    py={3}
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    fontWeight="semibold"
                    color="#c0a316"
                  >
                    {rentPercent}%
                  </Td>
                </Tr>
              );
            })
          )
        ) : (
          <Tr>
            <Td colSpan={11} textAlign="center" py={8} color="gray.500">
              Não foram encontrados pedidos.
            </Td>
          </Tr>
        )}
      </Tbody>

      {/* Rodapé da tabela com os totais e médias */}
      <Tfoot bg="gray.50">
        <Tr>
          <Th
            colSpan={4}
            textAlign="right"
            px={4}
            py={3}
            fontWeight="bold"
            color="#007abe"
            borderTop="2px solid"
            borderColor="#007abe"
          >
            TOTAIS:
          </Th>
          <Td
            px={4}
            py={3}
            fontWeight="bold"
            color="#007abe"
            borderTop="2px solid"
            borderColor="#007abe"
          >
            {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totais.valorTotal)}
          </Td>
          <Td
            px={4}
            py={3}
            fontWeight="bold"
            color="#007abe"
            borderTop="2px solid"
            borderColor="#007abe"
          >
            {totais.volumeTotal.toFixed(2)}
          </Td>
          <Td borderTop="2px solid" borderColor="#007abe" />
          <Td
            px={4}
            py={3}
            fontWeight="bold"
            color="#007abe"
            borderTop="2px solid"
            borderColor="#007abe"
          >
            {totais.quantidadeTotal}
          </Td>
          <Td borderTop="2px solid" borderColor="#007abe" />
          <Td borderTop="2px solid" borderColor="#007abe" />
          <Td borderTop="2px solid" borderColor="#007abe" />
        </Tr>
        <Tr>
          <Th
            colSpan={4}
            textAlign="right"
            px={4}
            py={3}
            fontWeight="bold"
            color="#007abe"
          >
            MÉDIA:
          </Th>
          <Td px={4} py={3}></Td>
          <Td px={4} py={3}></Td>
          <Td px={4} py={3}></Td>
          <Td px={4} py={3}></Td>
          <Td px={4} py={3}></Td>
          <Td px={4} py={3} fontWeight="bold" color="#c0a316">
            {mediaRentRsLt}
          </Td>
          <Td px={4} py={3} fontWeight="bold" color="#c0a316">
            {mediaRentPercent}%
          </Td>
        </Tr>
      </Tfoot>
    </Table>
  );
};

export default PedidoTable;
